import React, { useState, useEffect, useContext } from 'react'
import Table from "components/Table/Table";
import UserDetailsAPI from 'apis/userDetails/UserDetails';
import Context from 'context/context';
import searchIcon from "assets/img/Search_Icon.png";
import { styles } from './styles'
import { toast } from "react-toastify";
import { CSVLink } from 'react-csv';
import * as moment from "moment";
import useDebounce from "helpers/useDebounce";


import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import { MenuItem } from '@material-ui/core'

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { blockInvalidCharForText } from 'helpers/blockInvalidCharForText';

// custom TextField
const CssTextField = withStyles({
    root: {
        "& label.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormLabel-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: 20,
            },
            "&.MuiOutlinedInput-root": {
                marginTop: 0,
                borderRadius: 20,
                background: "#ededed",
            },
        },
    },
})(TextField);

const sendEmailTransition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function CreateOnewebAllowedUser() {
    const { getOnewebAllowedUsersAPI, searchOnewebAllowedUsersAPI, createOnewebAllowedUsersAPI, deleteOnewebAllowedUsersAPI } = UserDetailsAPI()
    const { state, dispatch } = useContext(Context)
    const classes = styles();
    const [data, setData] = useState([])
    const [offset, setOffset] = useState(1);
    const [count, setCount] = useState(0);
    const [loading, setLoading] = useState(true)
    const [searchValue, setSearchValue] = useState("")
    const [createObj, setCreateObj] = useState({       
        guid: '',
        type: ''
    });
    const [popupOpen, setPopupOpen] = useState(false);
    const searchBounceValues = useDebounce(searchValue);

    useEffect(() => {
        if (searchBounceValues && searchBounceValues.length > 0) {
            handleSearch()
        } else {
            getUserDetails()
        }
    }, [searchBounceValues, offset])

    async function getUserDetails() {
        try {
            setLoading(true)
            let values;
            values = {
                offset: (offset - 1) * 10,
                limit: 10,
            };

            dispatch({ type: "SET_LOADING", payload: true });
            let res = await getOnewebAllowedUsersAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleSearch() {
        try {
            setLoading(true)
            let values;
            values = {
                searchValue,
                offset: (offset - 1) * 10,
                limit: 10,
            };

            dispatch({ type: "SET_LOADING", payload: true });
            let res = await searchOnewebAllowedUsersAPI(values);
            if (res) {
                setData(res.data);
                setCount(res.count);
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleCreate() {
        try {
            const { guid, type } = createObj;
            if (!guid || !type) {
                return toast.error('Please fill all the fields');
            }
            setLoading(true);
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await createOnewebAllowedUsersAPI(createObj);
            if (res.type == 'success') {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.success(res.message)
                setPopupOpen(false)
                getUserDetails();
            } else {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.error(res.message)
            }
        } catch (e) {
            console.log({ e });
        }
    }

    async function handleDelete(guid) {
        try {
            setLoading(true);
            dispatch({ type: "SET_LOADING", payload: true });
            let res = await deleteOnewebAllowedUsersAPI({ guid });
            if (res.type == 'success') {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.success(res.message)
                getUserDetails();
            } else {
                setLoading(false)
                dispatch({ type: "SET_LOADING", payload: false });
                toast.error(res.message)
            }
        } catch (e) {
            console.log({ e });
        }
    }

    let tableHeading = [
        "GUID",
        "type",
        "Org",
        "Site",
        ""
    ];

    const handlePagination = (value) => {
        setOffset(value);
    };

    return (
        <div>
            <h2>Oneweb Allowed Users</h2>
            <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
                <Grid>
                    <CssTextField
                        id="enterPassword"
                        placeholder={'Search for Shipto or GUID'}
                        onKeyDown={blockInvalidCharForText}
                        type={"text"}
                        variant="outlined"
                        autoComplete="off"
                        className={classes.searchInput}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {searchValue.length > 0 ? (
                                        <CloseOutlinedIcon
                                            className={classes.searchInputIcon}
                                            onClick={() => {
                                                setSearchValue("");
                                                setOffset(1);
                                                getUserDetails();
                                            }}
                                        />
                                    ) : (
                                        <img
                                            src={searchIcon}
                                            alt=""
                                            width="20px"
                                            className={classes.searchInputIcon}
                                        />
                                    )}
                                </InputAdornment>
                            ),
                        }}
                        value={searchValue}
                        onChange={(e) => {
                            e.target.value.replace(/\s+/g, "").length == 0
                                ? setSearchValue("")
                                : setSearchValue(e.target.value);
                            if (e.target.value.length == 0) {
                                getUserDetails();
                            }
                        }}
                        onClick={() => {
                            setOffset(1);
                        }}
                    />
                    <Button
                        className={`${classes.createBtn} dash-1-filter-btn`}
                        onClick={() => {
                            setPopupOpen(true)
                        }}
                    >
                        {'Create'}
                    </Button>
                </Grid>
            </Grid>
            <div style={{ marginTop: 20 }}>
                {!loading ? <Table
                    headings={tableHeading.map((i) => {
                        return <div key={i}>{i}</div>
                    })}
                    data={data &&
                        data.length > 0 &&
                        data.map((p) => [                            
                            [p?.integration_user_id],
                            [p?.type],
                            [p?.loyalty_organization_name],
                            [p?.loyalty_site_id],
                            [
                                <Button
                                    className={`${classes.createBtn} dash-1-filter-btn`}
                                    onClick={() => {
                                        handleDelete(p?.integration_user_id)
                                    }}
                                >
                                    {'Delete'}
                                </Button>
                            ]
                        ])}
                    offset={offset}
                    count={
                        (count / 10) % 1 == 0
                            ? Math.floor(count / 10)
                            : Math.floor(count / 10 + 1)
                    }
                    handlePagination={handlePagination}
                /> :
                    <div style={{ height: '25vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h2>Loading...</h2>
                    </div>}
            </div>
            <Dialog
                open={popupOpen == true}
                TransitionComponent={sendEmailTransition}
                keepMounted
                onClose={() => setPopupOpen(false)}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        <span
                            style={{ float: "right", color: "red", cursor: "pointer" }}
                            onClick={() => {
                                setPopupOpen(false);
                            }}
                        >
                            X
                        </span>
                    </DialogContentText>                    
                    <TextField
                        id="guid"
                        placeholder={'Enter GUID'}
                        type={"text"}
                        style={{ margin: 10, width: '90%' }}
                        variant="outlined"
                        autoComplete="off"
                        value={createObj?.guid}
                        onChange={(e) => {
                            setCreateObj({ ...createObj, guid: e.target.value })
                        }}
                    />
                    <TextField
                        id="type"
                        placeholder={'Select Type'}
                        select
                        style={{ margin: 10, width: '90%' }}
                        variant="outlined"
                        autoComplete="off"
                        value={createObj.type}
                        onChange={(e) => {
                            setCreateObj({ ...createObj, type: e.target.value })
                        }}
                    >
                        <MenuItem value="LOGIN">LOGIN</MenuItem>
                        <MenuItem value="ENROLLMENT">ENROLLMENT</MenuItem>
                    </TextField>
                    <Button
                        className={`${classes.createBtn} dash-1-filter-btn`}
                        style={{ width: 120, marginLeft: '40%' }}
                        onClick={handleCreate}
                    >
                        {'Submit'}
                    </Button>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default CreateOnewebAllowedUser;